import { isValid, UTCDate } from '@/utils/dates';
import { InvoiceEvidenceView } from '../../../../../types/entity-types';

export const sortEvidencesByTxnFspDateNewestToOldest = (evidences: InvoiceEvidenceView[]) => {
  return evidences.sort((a, b) => {
    const sanitisedFspDateA =
      !a.transaction?.fspDate || !isValid(new UTCDate(a.transaction?.fspDate)) ? 'Unknown' : a.transaction.fspDate;
    const sanitisedFspDateB =
      !b.transaction?.fspDate || !isValid(new UTCDate(b.transaction?.fspDate)) ? 'Unknown' : b.transaction.fspDate;

    if (sanitisedFspDateA === 'Unknown' && sanitisedFspDateB !== 'Unknown') {
      return -1;
    }

    if (sanitisedFspDateB === 'Unknown' && sanitisedFspDateA !== 'Unknown') {
      return 1;
    }

    if (sanitisedFspDateA === 'Unknown' && sanitisedFspDateB === 'Unknown') {
      return 0;
    }

    return new UTCDate(sanitisedFspDateB).getTime() - new UTCDate(sanitisedFspDateA).getTime();
  });
};
